"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupPicker = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindGroups_1 = require("../hooks/useFindGroups");
function compareIds(id, value) {
    return Array.isArray(value) ? value.includes(id) : id === value;
}
const GroupPicker = props => {
    const { value, disabled, multiple, textFieldProps, onChange } = props;
    const [search, setSearch] = (0, react_1.useState)('');
    const debouncedSearch = (0, core_ui_1.useDebounce)(search, 300);
    const { groupList, isLoading, error, findGroups } = (0, useFindGroups_1.useFindGroups)();
    const options = (groupList === null || groupList === void 0 ? void 0 : groupList.data) || [];
    const groups = options.filter(option => compareIds(option.id, value));
    const groupsKey = groups.map(group => group.id).join(',');
    // avoid re-rendering by updating selected only when groups change
    const selected = (0, react_1.useMemo)(() => {
        return multiple ? groups : groups[0] || null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupsKey, multiple]);
    (0, react_1.useEffect)(() => {
        findGroups({ search: debouncedSearch });
    }, [debouncedSearch, findGroups]);
    return (react_1.default.createElement(lab_1.Autocomplete, { className: 'field', value: selected, options: options, disabled: disabled, loading: isLoading, multiple: multiple, getOptionLabel: option => option.name, getOptionSelected: option => compareIds(option.id, value), onInputChange: (_, value) => setSearch(value || ''), onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value), renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Select Team' }, textFieldProps, { error: !!((error === null || error === void 0 ? void 0 : error.message) || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.error)), helperText: (error === null || error === void 0 ? void 0 : error.message) || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.helperText) }))) }));
};
exports.GroupPicker = GroupPicker;
exports.default = exports.GroupPicker;
//# sourceMappingURL=GroupPicker.js.map